// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { BaseIcon } from '@fs/zion-icon/BaseIcon'

export default (props) => (
  <BaseIcon {...sanitizeProps(props)}>
    <path d="M21.7 7.13a2.54 2.54 0 0 0-1.79-1.79C18.33 4.91 12 4.91 12 4.91s-6.33 0-7.91.42a2.53 2.53 0 0 0-1.8 1.8c-.4 1.57-.4 4.87-.4 4.87s0 3.3.42 4.88a2.54 2.54 0 0 0 1.79 1.79c1.58.42 7.91.42 7.91.42s6.33 0 7.91-.42a2.54 2.54 0 0 0 1.8-1.8c.41-1.57.41-4.87.41-4.87s0-3.3-.42-4.87ZM9.98 15.04V8.97L15.22 12l-5.26 3.04Z" />
  </BaseIcon>
)
